import React from 'react'
import gradYearToGradeNumber from '../../../utilities/grade-number'
import utilities from '../../../utilities'

const parseName = ({
    lastName,
    firstName,
    email
}) => {
    if (lastName && firstName) {
        return `${lastName}, ${firstName}`
    }

    if (lastName || firstName) {
        return lastName || firstName
    }

    return email
}

const UserLastFirstName = ({
    user,
    style = {},
    showGradeNumber
}) => {
    const name = utilities.getUserFullName(user, { grade: showGradeNumber, familyFirst: true })

    return (
        <span style={style}>
            {name}
        </span>
    )
}

export default UserLastFirstName